import { SymbolTypeEnum } from 'modules/Transfer/type';

export const titleMap: Record<SymbolTypeEnum, string> = {
    [SymbolTypeEnum.STOCK]: __('Transfer Stock and ETF Details'),
    [SymbolTypeEnum.OPTION]: __('Transfer Option Details'),
    [SymbolTypeEnum.MUTUAL_FUND]: __('Transfer Mutual Fund Details')
};

export const symbolLabelMap: Record<SymbolTypeEnum, string> = {
    [SymbolTypeEnum.STOCK]: __('Transfer:Stock Symbol'),
    [SymbolTypeEnum.OPTION]: __('Transfer:Option Contract'),
    [SymbolTypeEnum.MUTUAL_FUND]: __('Transfer:Fund Ticker')
};

export const symbolPlaceholderMap: Record<SymbolTypeEnum, string> = {
    [SymbolTypeEnum.STOCK]: __('Please input stock symbol or stock name'),
    [SymbolTypeEnum.OPTION]: __('Please input option contract'),
    [SymbolTypeEnum.MUTUAL_FUND]: __('Please input fund ticker')
};

export const stockLongShortOptions = [
    { label: __('Transfer:Long'), value: 'long', description: __('LongShort:StockLongDesc') },
    { label: __('Transfer:Short'), value: 'short', description: __('LongShort:StockShortDesc') }
];

export const optionLongShortOptions = [
    { label: __('Transfer:Long'), value: 'long', description: __('LongShort:OptionLongDesc') },
    { label: __('Transfer:Short'), value: 'short', description: __('LongShort:OptionShortDesc') }
];

/**
 * Normalizes a ticker symbol by trimming whitespace and converting to uppercase
 */
export const normalizeTicker = (raw: string): string => {
    return (raw || '').trim().toUpperCase();
};

/**
 * Symbol type navigation configuration
 */
export const SYMBOL_TYPE_ROUTES = {
    [SymbolTypeEnum.STOCK]: {
        addPath: '../fill-stock',
        editStateKey: 'editStockName'
    },
    [SymbolTypeEnum.OPTION]: {
        addPath: '../fill-option',
        editStateKey: 'editOptionName'
    },
    [SymbolTypeEnum.MUTUAL_FUND]: {
        addPath: '../fill-fund',
        editStateKey: 'editFundSymbol'
    }
} as const;
